module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "id": "map",
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1998.9855516461898!2d30.36271511155701!3d59.932381918016056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x469631a3530d71b9%3A0xf49c938b06567eeb!2z0JvQuNCz0L7QstGB0LrQuNC5INC_0YAuLCAxMCAvIDExOCwg0KHQsNC90LrRgi3Qn9C10YLQtdGA0LHRg9GA0LMsIDE5MTAzNg!5e0!3m2!1sru!2sru!4v1725462475530!5m2!1sru!2sru",
      "height": _vm.height,
      "allowfullscreen": "",
      "loading": "lazy",
      "referrerpolicy": "no-referrer-when-downgrade"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 centered"
  }, [_c('p'), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "tel:+78129161500"
    }
  }, [_vm._v("Телефон: +7 (812) 916-15-00")])]), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86672b1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contacts.vue
// module id = 239
// module chunks = 1